export const languages = [
  {
    language_id: "1",
    code: "en",
    label: "English",
    short: "EN",
  },
  {
    language_id: "2",
    code: "pt",
    label: "Portuguese",
    short: "PT",
  },
];
export const countryCode = "258";

export const isValidUrl = (str) => {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
};
